import { render, staticRenderFns } from "./OrdersModal.vue?vue&type=template&id=012963d9&scoped=true"
import script from "./OrdersModal.vue?vue&type=script&lang=js"
export * from "./OrdersModal.vue?vue&type=script&lang=js"
import style0 from "./OrdersModal.vue?vue&type=style&index=0&id=012963d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012963d9",
  null
  
)

export default component.exports